// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"7f58613d","266":"7f58613d","485":"7f58613d","706":"7f58613d","727":"7f58613d","781":"7f58613d","860":"7f58613d"}[chunkId] + ".chunk.css";
};